export const MINUTES = 60 * 1000
